var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharactersArtifactsDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 810,
    viewBox: "0 0 1440 810",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 441,
    className: "st0",
    width: 9,
    height: 9,
    fill: "#E9ABE1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 395,
    className: "st0",
    width: 5,
    height: 4,
    fill: "#E9ABE1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 232.6,
    y: 614,
    className: "st0",
    width: 9,
    height: 8,
    fill: "#E9ABE1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 231.6,
    y: 658,
    className: "st0",
    width: 2,
    height: 2,
    fill: "#E9ABE1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 153.6,
    y: 659,
    className: "st0",
    width: 2,
    height: 2,
    fill: "#E9ABE1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 153.6,
    y: 702,
    className: "st0",
    width: 12,
    height: 2,
    fill: "#E9ABE1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 307,
    className: "st0",
    width: 12,
    height: 2,
    fill: "#E9ABE1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 263,
    className: "st0",
    width: 12,
    height: 2,
    fill: "#E9ABE1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 219,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 180,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 175,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 175,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 180,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1330,
    y: 183,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1094.6,
    y: 128,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 183,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1084.6,
    y: 128,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1330,
    y: 188,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1094.6,
    y: 133,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 188,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1084.6,
    y: 133,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1331,
    y: 228,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 883.9,
    y: 448,
    className: "st0",
    width: 7,
    height: 7,
    fill: "#E9ABE1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 887.9,
    y: 464,
    className: "st0",
    width: 3,
    height: 1,
    fill: "#E9ABE1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 887.9,
    y: 468,
    className: "st0",
    width: 3,
    height: 1,
    fill: "#E9ABE1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 905,
    y: 580,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 751,
    y: 581,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1175.6,
    y: 128,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 828,
    y: 580,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 674,
    y: 581,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1326,
    y: 271,
    className: "st0",
    width: 9,
    height: 2,
    fill: "#E9ABE1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1326.5,
    y: 316,
    className: "st0",
    width: 9,
    height: 2,
    fill: "#E9ABE1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 179,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 179,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 179,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 179,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 174,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 174,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 174,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 174,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 134,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 451,
    y: 135,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 179,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 179,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 134,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 172,
    className: "st0",
    width: 9,
    height: 2,
    fill: "#E9ABE1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 127,
    className: "st0",
    width: 9,
    height: 2,
    fill: "#E9ABE1"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 1281.7,
    y: 744,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1271.7,
    y: 744,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1281.7,
    y: 739,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 1271.7,
    y: 739,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1282.7,
    y: 699,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 1203.7,
    y: 700,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 835.9,
    y: 474,
    className: "st0",
    width: 7,
    height: 7,
    fill: "#E9ABE1"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 839.9,
    y: 464,
    className: "st0",
    width: 3,
    height: 1,
    fill: "#E9ABE1"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 839.9,
    y: 460,
    className: "st0",
    width: 3,
    height: 1,
    fill: "#E9ABE1"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 523.7,
    y: 474,
    className: "st0",
    width: 7,
    height: 7,
    fill: "#E9ABE1"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 527.7,
    y: 464,
    className: "st0",
    width: 3,
    height: 1,
    fill: "#E9ABE1"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 527.7,
    y: 460,
    className: "st0",
    width: 3,
    height: 1,
    fill: "#E9ABE1"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 475.7,
    y: 448,
    className: "st0",
    width: 7,
    height: 7,
    fill: "#E9ABE1"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 479.7,
    y: 464,
    className: "st0",
    width: 3,
    height: 1,
    fill: "#E9ABE1"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 479.7,
    y: 468,
    className: "st0",
    width: 3,
    height: 1,
    fill: "#E9ABE1"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1204.7,
    y: 744,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 810.6,
    y: 347,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1127.7,
    y: 744,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 887.6,
    y: 347,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 450.7,
    y: 347,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 527.7,
    y: 347,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 1126.7,
    y: 699,
    className: "st0",
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 1277.7,
    y: 656,
    className: "st0",
    width: 9,
    height: 2,
    fill: "#E9ABE1"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1278.7,
    y: 611,
    className: "st0",
    width: 9,
    height: 2,
    fill: "#E9ABE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharactersArtifactsDesktop);
export default __webpack_public_path__ + "static/media/characters-artifacts-desktop.a7efdd28830771476f9552517fce0648.svg";
export { ForwardRef as ReactComponent };